/* eslint-disable */
import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Date (isoformat) */
  Date: { input: any; output: any };
  /** Time (isoformat) */
  Time: { input: any; output: any };
  UUID: { input: any; output: any };
};

export type Account = Node & {
  __typename?: 'Account';
  /** The ID of the account */
  id: Scalars['ID']['output'];
  shops: ShopConnection;
};

export type AccountShopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AddHolidayToShopInput = {
  /** The data for the shop holiday */
  shopHolidayData: NewShopHolidayDataInput;
  /** The ID of the shop to create the holiday in */
  shopId: Scalars['UUID']['input'];
};

export type AddHolidayToShopResponse =
  | InvalidShopHolidayInputsError
  | MissingShopError
  | ShopHolidayCreated;

export type AddLaneToShopInput = {
  /** The ID of the shop to create the lane in */
  shopId: Scalars['UUID']['input'];
  /** The data for the shop lane */
  shopLaneData: NewShopLaneDataInput;
};

export type AddLaneToShopResponse =
  | InvalidShopLaneInputsError
  | MissingShopError
  | ShopLaneCreated;

export type AppointmentLineInput = {
  cause?: InputMaybe<Scalars['String']['input']>;
  comebackFlag?: InputMaybe<Scalars['Boolean']['input']>;
  complaint: Scalars['String']['input'];
  concernCode?: InputMaybe<Scalars['String']['input']>;
  dispatchCode?: InputMaybe<Scalars['String']['input']>;
  estDuration?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  laborEstimate?: InputMaybe<Scalars['Float']['input']>;
  laborType: Scalars['String']['input'];
  lubeEstimate?: InputMaybe<Scalars['Float']['input']>;
  miscEstimate?: InputMaybe<Scalars['Float']['input']>;
  ops: Array<AppointmentOperationInput>;
  partsEstimate?: InputMaybe<Scalars['Float']['input']>;
  serviceEstimate?: InputMaybe<Scalars['Float']['input']>;
  serviceRequest: Scalars['String']['input'];
  subletEstimate?: InputMaybe<Scalars['Float']['input']>;
  taxEstimate?: InputMaybe<Scalars['Float']['input']>;
  technician?: InputMaybe<Scalars['String']['input']>;
  urgencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type AppointmentOperationInput = {
  forceShopCharge: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  labor: Scalars['String']['input'];
  opCode: Scalars['String']['input'];
  opCodeDesc: Scalars['String']['input'];
  parts?: InputMaybe<Array<AppointmentPartInput>>;
  saleAmount?: InputMaybe<Scalars['String']['input']>;
  saleOverride: Scalars['Boolean']['input'];
  shopCharge?: InputMaybe<Scalars['String']['input']>;
  soldHours: Scalars['String']['input'];
};

export type AppointmentPartInput = {
  coreFlag: Scalars['Boolean']['input'];
  fixedSale: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  mfrCode: Scalars['String']['input'];
  partDesc: Scalars['String']['input'];
  partNo: Scalars['String']['input'];
  partQty: Scalars['Int']['input'];
  priceOrigin: Scalars['String']['input'];
  saleAmount: Scalars['String']['input'];
};

export type AppointmentResponse = {
  __typename?: 'AppointmentResponse';
  apptDate: Scalars['String']['output'];
  apptId: Scalars['String']['output'];
  apptTime: Scalars['String']['output'];
  checkSum: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  customerContactInfo?: Maybe<Scalars['String']['output']>;
  customerFullName?: Maybe<Scalars['String']['output']>;
  customerPartyId?: Maybe<Scalars['String']['output']>;
  customerTransportation?: Maybe<Scalars['String']['output']>;
  customerWaiterFlag?: Maybe<Scalars['Boolean']['output']>;
  dealerReservationist?: Maybe<Scalars['String']['output']>;
  dealerServiceAdvisor?: Maybe<Scalars['String']['output']>;
  dispatchMakeCode?: Maybe<Scalars['String']['output']>;
  lineCount: Scalars['Int']['output'];
  opCount: Scalars['Int']['output'];
  originAppl: Scalars['String']['output'];
  originCode?: Maybe<Scalars['String']['output']>;
  partsCount: Scalars['Int']['output'];
  promiseDate?: Maybe<Scalars['String']['output']>;
  promiseTime?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
  vehicleModelYear?: Maybe<Scalars['Int']['output']>;
  vehicleOdometerStatus?: Maybe<Scalars['Int']['output']>;
};

export type AppointmentResponseMissingSettingsAppointmentError =
  | AppointmentResponse
  | MissingSettingsAppointmentError;

export type CreateAppointmentInput = {
  apptDate: Scalars['Date']['input'];
  apptTime: Scalars['Time']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<CustomerInput>;
  dealer: DealerInput;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  dispatchMakeCode?: InputMaybe<Scalars['String']['input']>;
  lineCount: Scalars['Int']['input'];
  lines: Array<AppointmentLineInput>;
  opCount: Scalars['Int']['input'];
  originAppl: Scalars['String']['input'];
  originCode?: InputMaybe<Scalars['String']['input']>;
  partsCount: Scalars['Int']['input'];
  promiseDate?: InputMaybe<Scalars['Date']['input']>;
  promiseTime?: InputMaybe<Scalars['Time']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  totals?: InputMaybe<TotalsInput>;
  vehicle: VehicleInput;
};

export type CreateShopInput = {
  /** The account this shop is in */
  accountId: Scalars['UUID']['input'];
  /** The rooftop this shop is in */
  rooftopId: Scalars['UUID']['input'];
  /** The data for the shop */
  shopData: ShopDataInput;
};

export type CreateShopResponse =
  | InvalidShopInputsError
  | MissingAccountError
  | ShopCreated;

export type CustomerInput = {
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<CustomerNameInput>;
  partyId?: InputMaybe<CustomerPartyIdInput>;
  transportation?: InputMaybe<Scalars['String']['input']>;
  waiterFlag: Scalars['Boolean']['input'];
};

export type CustomerNameInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPartyIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DealerInput = {
  reservationist?: InputMaybe<Scalars['String']['input']>;
  serviceAdvisor: Scalars['String']['input'];
};

export type DeleteShopHolidayInput = {
  /** The ID of the shop holiday to delete */
  shopHolidayId: Scalars['UUID']['input'];
  /** The ID of the shop */
  shopId: Scalars['UUID']['input'];
};

export type DeleteShopHolidayResponse =
  | MissingShopError
  | MissingShopHolidayError
  | ShopHolidayDeleted;

export type DeleteShopInput = {
  /** The ID of the shop to delete */
  shopId: Scalars['UUID']['input'];
};

export type DeleteShopLaneInput = {
  /** The ID of the shop lane to delete */
  shopLaneId: Scalars['UUID']['input'];
};

export type DeleteShopLaneResponse = MissingShopLaneError | ShopLaneDeleted;

export type DeleteShopResponse = MissingShopError | ShopDeleted;

export enum HolidayDateType {
  Exact = 'EXACT',
  Variable = 'VARIABLE',
}

export type InvalidShopHolidayInputsError = {
  __typename?: 'InvalidShopHolidayInputsError';
  items: Array<Scalars['String']['output']>;
};

export type InvalidShopInputsError = {
  __typename?: 'InvalidShopInputsError';
  items: Array<Scalars['String']['output']>;
};

export type InvalidShopLaneInputsError = {
  __typename?: 'InvalidShopLaneInputsError';
  items: Array<Scalars['String']['output']>;
};

export type MapShopServiceCategoryToLaneInput = {
  /** The ID of the shop lane to map */
  shopLaneId?: InputMaybe<Scalars['UUID']['input']>;
  /** The ID of the shop service category to map */
  shopServiceCategoryId: Scalars['UUID']['input'];
};

export type MapShopServiceCategoryToLaneResponse =
  | MappedShopServiceCategoryToLane
  | MissingShopLaneError
  | MissingShopServiceCategoryError;

export type MappedShopServiceCategoryToLane = {
  __typename?: 'MappedShopServiceCategoryToLane';
  shopServiceCategory: ShopServiceCategory;
};

export type MissingAccountError = {
  __typename?: 'MissingAccountError';
  accountId: Scalars['String']['output'];
};

export type MissingSettingsAppointmentError = {
  __typename?: 'MissingSettingsAppointmentError';
  message: Scalars['String']['output'];
};

export type MissingShopError = {
  __typename?: 'MissingShopError';
  shopId: Scalars['String']['output'];
};

export type MissingShopHolidayError = {
  __typename?: 'MissingShopHolidayError';
  shopHolidayId: Scalars['String']['output'];
};

export type MissingShopLaneError = {
  __typename?: 'MissingShopLaneError';
  shopLaneId: Scalars['String']['output'];
};

export type MissingShopServiceCategoryError = {
  __typename?: 'MissingShopServiceCategoryError';
  shopServiceCategoryId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addHolidayToShop: AddHolidayToShopResponse;
  addLaneToShop: AddLaneToShopResponse;
  createAppointment?: Maybe<AppointmentResponseMissingSettingsAppointmentError>;
  createShop: CreateShopResponse;
  deleteShop: DeleteShopResponse;
  deleteShopHoliday: DeleteShopHolidayResponse;
  deleteShopLane: DeleteShopLaneResponse;
  mapShopServiceCategoryToLane: MapShopServiceCategoryToLaneResponse;
  setShopLanePosition: SetShopLanePositionResponse;
  updateShop: UpdateShopResponse;
  updateShopHoliday: UpdateShopHolidayResponse;
  updateShopLane: UpdateShopLaneResponse;
};

export type MutationAddHolidayToShopArgs = {
  input: AddHolidayToShopInput;
};

export type MutationAddLaneToShopArgs = {
  input: AddLaneToShopInput;
};

export type MutationCreateAppointmentArgs = {
  input: CreateAppointmentInput;
};

export type MutationCreateShopArgs = {
  input: CreateShopInput;
};

export type MutationDeleteShopArgs = {
  input: DeleteShopInput;
};

export type MutationDeleteShopHolidayArgs = {
  input: DeleteShopHolidayInput;
};

export type MutationDeleteShopLaneArgs = {
  input: DeleteShopLaneInput;
};

export type MutationMapShopServiceCategoryToLaneArgs = {
  input: MapShopServiceCategoryToLaneInput;
};

export type MutationSetShopLanePositionArgs = {
  input: SetShopLanePositionInput;
};

export type MutationUpdateShopArgs = {
  input: UpdateShopInput;
};

export type MutationUpdateShopHolidayArgs = {
  input: UpdateShopHolidayInput;
};

export type MutationUpdateShopLaneArgs = {
  input: UpdateShopLaneInput;
};

export type NewShopHolidayDataInput = {
  /** Day of month for exact date holidays (1-31). Required for EXACT holidays. */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Type of holiday date: exact (specific date) or variable (nth weekday) */
  holidayDateType: HolidayDateType;
  /** Whether this holiday is currently active */
  isActive: Scalars['Boolean']['input'];
  /** Month of the holiday (1-12) */
  isoMonth: Scalars['Int']['input'];
  /** Day of week for variable holidays (1=Monday, 7=Sunday). Required for VARIABLE holidays. */
  isoWeekday?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Nth occurrence of weekday in month (1-4, or -1 for last). Required for VARIABLE holidays. */
  nthOccurrence?: InputMaybe<Scalars['Int']['input']>;
};

export type NewShopLaneDataInput = {
  /** How many appointments can be booked in this lane per interval (0 = unlimited) */
  appointmentsPerIntervalLimit: Scalars['Int']['input'];
  /** How many appointments can be booked in this lane in total per day (0 = unlimited) */
  dailyAppointmentLimit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  /** How this lane is ordered amongst others (lowest number is first, highest number is last) */
  ordinal: Scalars['Int']['input'];
};

/** An object with a Globally Unique ID */
export type Node = {
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
};

/** Information to aid in pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  rooftop?: Maybe<Rooftop>;
  shop?: Maybe<Shop>;
};

export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRooftopArgs = {
  id: Scalars['ID']['input'];
};

export type QueryShopArgs = {
  id: Scalars['ID']['input'];
};

export type Rooftop = Node & {
  __typename?: 'Rooftop';
  /** The ID of the rooftop */
  id: Scalars['ID']['output'];
  shops: ShopConnection;
};

export type RooftopShopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SetShopLanePositionInput = {
  /** The new position of the shop lane */
  position: Scalars['Int']['input'];
  /** The ID of the shop lane to update */
  shopLaneId: Scalars['UUID']['input'];
};

export type SetShopLanePositionResponse =
  | InvalidShopLaneInputsError
  | MissingShopLaneError
  | ShopLanePositionUpdated;

export type Shop = Node & {
  __typename?: 'Shop';
  city: Scalars['String']['output'];
  /** How many appointments can be booked per day */
  dailyAppointmentLimit: Scalars['Int']['output'];
  /** The holidays observed by the shop */
  holidays: Array<ShopHoliday>;
  /** What hours the shop is open */
  hours: Array<ShopHour>;
  /** The ID of the shop */
  id: Scalars['ID']['output'];
  /** How long each appointment slot is in minutes */
  intervalDurationMinutes: Scalars['Int']['output'];
  /** The lanes in the shop */
  lanes: Array<ShopLane>;
  name: Scalars['String']['output'];
  /** Service categories in the shop */
  serviceCategories: Array<ShopServiceCategory>;
  serviceLeadXmlAddress: Scalars['String']['output'];
  state: Scalars['String']['output'];
  /** Whether the shop is active */
  status: ShopStatusGql;
  streetAddress: Scalars['String']['output'];
  /** A tzdata timezone string */
  timezone: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ShopConnection = {
  __typename?: 'ShopConnection';
  /** Contains the nodes in this connection */
  edges: Array<ShopEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
};

export type ShopCreated = {
  __typename?: 'ShopCreated';
  shop: Shop;
};

export type ShopDataInput = {
  city: Scalars['String']['input'];
  /** How many appointments can be booked per day */
  dailyAppointmentLimit: Scalars['Int']['input'];
  /** What hours the shop is open */
  hours: Array<ShopHourInput>;
  /** How long each appointment slot is */
  intervalDurationMinutes: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  serviceLeadXmlAddress: Scalars['String']['input'];
  state: Scalars['String']['input'];
  /** Whether the shop is active */
  status: ShopStatusGql;
  streetAddress: Scalars['String']['input'];
  /** A tzdata timezone string */
  timezone: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type ShopDeleted = {
  __typename?: 'ShopDeleted';
  shopId: Scalars['String']['output'];
};

/** An edge in a connection. */
export type ShopEdge = {
  __typename?: 'ShopEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Shop;
};

export type ShopHoliday = {
  __typename?: 'ShopHoliday';
  /** Day of month for exact date holidays (1-31). Required for EXACT holidays. */
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** Type of holiday date: exact (specific date) or variable (nth weekday) */
  holidayDateType: HolidayDateType;
  id: Scalars['ID']['output'];
  /** Whether this holiday is currently active */
  isActive: Scalars['Boolean']['output'];
  /** Month of the holiday (1-12) */
  isoMonth: Scalars['Int']['output'];
  /** Day of week for variable holidays (1=Monday, 7=Sunday). Required for VARIABLE holidays. */
  isoWeekday?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Nth occurrence of weekday in month (1-4, or -1 for last). Required for VARIABLE holidays. */
  nthOccurrence?: Maybe<Scalars['Int']['output']>;
};

export type ShopHolidayCreated = {
  __typename?: 'ShopHolidayCreated';
  shopHoliday: ShopHoliday;
};

export type ShopHolidayDeleted = {
  __typename?: 'ShopHolidayDeleted';
  shopHolidayId: Scalars['String']['output'];
};

export type ShopHolidayUpdated = {
  __typename?: 'ShopHolidayUpdated';
  shopHoliday: ShopHoliday;
};

export type ShopHour = {
  __typename?: 'ShopHour';
  /** The time the shop closes */
  closeTime: Scalars['Time']['output'];
  /** Integer for the day of the week, 1 = Monday, 7 = Sunday */
  isoDayOfWeek: Scalars['Int']['output'];
  /** The time the shop opens */
  openTime: Scalars['Time']['output'];
};

export type ShopHourInput = {
  /** The time the shop closes */
  closeTime: Scalars['Time']['input'];
  /** Integer for the day of the week, 1 = Monday, 7 = Sunday */
  isoDayOfWeek: Scalars['Int']['input'];
  /** The time the shop opens */
  openTime: Scalars['Time']['input'];
};

export type ShopLane = {
  __typename?: 'ShopLane';
  /** How many appointments can be booked in this lane per interval (0 = unlimited) */
  appointmentsPerIntervalLimit: Scalars['Int']['output'];
  /** How many appointments can be booked in this lane in total per day (0 = unlimited) */
  dailyAppointmentLimit: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** How this lane is ordered amongst others (lowest number is first, highest number is last) */
  ordinal: Scalars['Int']['output'];
};

export type ShopLaneCreated = {
  __typename?: 'ShopLaneCreated';
  shopLane: ShopLane;
};

export type ShopLaneDeleted = {
  __typename?: 'ShopLaneDeleted';
  shopLaneId: Scalars['String']['output'];
};

export type ShopLanePositionUpdated = {
  __typename?: 'ShopLanePositionUpdated';
  shopLane: ShopLane;
};

export type ShopLaneUpdated = {
  __typename?: 'ShopLaneUpdated';
  shopLane: ShopLane;
};

export type ShopServiceCategory = {
  __typename?: 'ShopServiceCategory';
  id: Scalars['ID']['output'];
  /** Lane corresponding to the minimum required skill level for this category */
  minimumRequiredLane?: Maybe<ShopLane>;
  name: Scalars['String']['output'];
};

export enum ShopStatusGql {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}

export type ShopUpdated = {
  __typename?: 'ShopUpdated';
  shop: Shop;
};

export type TotalsInput = {
  authorizedEstimate?: InputMaybe<Scalars['Float']['input']>;
  laborEstimate?: InputMaybe<Scalars['Float']['input']>;
  lubeEstimate?: InputMaybe<Scalars['Float']['input']>;
  miscEstimate?: InputMaybe<Scalars['Float']['input']>;
  partsEstimate?: InputMaybe<Scalars['Float']['input']>;
  subletEstimate?: InputMaybe<Scalars['Float']['input']>;
  taxEstimate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateShopHolidayDataInput = {
  /** Day of month for exact date holidays (1-31). Required for EXACT holidays. */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Type of holiday date: exact (specific date) or variable (nth weekday) */
  holidayDateType: HolidayDateType;
  /** Whether this holiday is currently active */
  isActive?: Scalars['Boolean']['input'];
  /** Month of the holiday (1-12) */
  isoMonth: Scalars['Int']['input'];
  /** Day of week for variable holidays (1=Monday, 7=Sunday). Required for VARIABLE holidays. */
  isoWeekday?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Nth occurrence of weekday in month (1-4, or -1 for last). Required for VARIABLE holidays. */
  nthOccurrence?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateShopHolidayInput = {
  /** The data for the shop holiday */
  shopHolidayData: UpdateShopHolidayDataInput;
  /** The ID of the shop holiday to update */
  shopHolidayId: Scalars['UUID']['input'];
  /** The ID of the shop */
  shopId: Scalars['UUID']['input'];
};

export type UpdateShopHolidayResponse =
  | InvalidShopHolidayInputsError
  | MissingShopError
  | MissingShopHolidayError
  | ShopHolidayUpdated;

export type UpdateShopInput = {
  /** The data for the shop */
  shopData: ShopDataInput;
  /** The ID of the shop to update */
  shopId: Scalars['UUID']['input'];
};

export type UpdateShopLaneDataInput = {
  /** How many appointments can be booked in this lane per interval (0 = unlimited) */
  appointmentsPerIntervalLimit: Scalars['Int']['input'];
  /** How many appointments can be booked in this lane in total per day (0 = unlimited) */
  dailyAppointmentLimit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdateShopLaneInput = {
  /** The data for the shop lane */
  shopLaneData: UpdateShopLaneDataInput;
  /** The ID of the shop lane to update */
  shopLaneId: Scalars['UUID']['input'];
};

export type UpdateShopLaneResponse =
  | InvalidShopLaneInputsError
  | MissingShopLaneError
  | ShopLaneUpdated;

export type UpdateShopResponse =
  | InvalidShopInputsError
  | MissingShopError
  | ShopUpdated;

export type VehicleInput = {
  model?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  odometerStatus: Scalars['Int']['input'];
  vehicleId: Scalars['String']['input'];
};

export type ShopMetaFragment = {
  __typename?: 'Shop';
  id: string;
  name: string;
  status: ShopStatusGql;
} & { ' $fragmentName'?: 'ShopMetaFragment' };

export type ShopDetailsFragment = {
  __typename?: 'Shop';
  id: string;
  name: string;
  status: ShopStatusGql;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
  serviceLeadXmlAddress: string;
  timezone: string;
  intervalDurationMinutes: number;
  dailyAppointmentLimit: number;
  hours: Array<{
    __typename?: 'ShopHour';
    isoDayOfWeek: number;
    openTime: any;
    closeTime: any;
  }>;
} & { ' $fragmentName'?: 'ShopDetailsFragment' };

export type ShopHourDetailsFragment = {
  __typename?: 'ShopHour';
  isoDayOfWeek: number;
  openTime: any;
  closeTime: any;
} & { ' $fragmentName'?: 'ShopHourDetailsFragment' };

export type ShopLaneDetailsFragment = {
  __typename?: 'ShopLane';
  id: string;
  name: string;
  ordinal: number;
  dailyAppointmentLimit: number;
  appointmentsPerIntervalLimit: number;
} & { ' $fragmentName'?: 'ShopLaneDetailsFragment' };

export type ShopHolidayDetailsFragment = {
  __typename?: 'ShopHoliday';
  id: string;
  name: string;
  holidayDateType: HolidayDateType;
  isoMonth: number;
  dayOfMonth?: number | null;
  isoWeekday?: number | null;
  nthOccurrence?: number | null;
  isActive: boolean;
} & { ' $fragmentName'?: 'ShopHolidayDetailsFragment' };

export type ShopsInAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type ShopsInAccountQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    id: string;
    shops: {
      __typename?: 'ShopConnection';
      edges: Array<{
        __typename?: 'ShopEdge';
        node: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopMetaFragment: ShopMetaFragment };
        };
      }>;
    };
  } | null;
};

export type ShopsInRooftopQueryVariables = Exact<{
  rooftopId: Scalars['ID']['input'];
}>;

export type ShopsInRooftopQuery = {
  __typename?: 'Query';
  rooftop?: {
    __typename?: 'Rooftop';
    id: string;
    shops: {
      __typename?: 'ShopConnection';
      edges: Array<{
        __typename?: 'ShopEdge';
        node: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopMetaFragment: ShopMetaFragment };
        };
      }>;
    };
  } | null;
};

export type GetShopQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetShopQuery = {
  __typename?: 'Query';
  shop?:
    | ({ __typename?: 'Shop' } & {
        ' $fragmentRefs'?: { ShopDetailsFragment: ShopDetailsFragment };
      })
    | null;
};

export type GetShopHoursQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;

export type GetShopHoursQuery = {
  __typename?: 'Query';
  shop?: {
    __typename?: 'Shop';
    hours: Array<
      { __typename?: 'ShopHour' } & {
        ' $fragmentRefs'?: { ShopHourDetailsFragment: ShopHourDetailsFragment };
      }
    >;
  } | null;
};

export type GetShopLanesQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;

export type GetShopLanesQuery = {
  __typename?: 'Query';
  shop?: {
    __typename?: 'Shop';
    lanes: Array<
      { __typename?: 'ShopLane' } & {
        ' $fragmentRefs'?: { ShopLaneDetailsFragment: ShopLaneDetailsFragment };
      }
    >;
  } | null;
};

export type GetShopHolidaysQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;

export type GetShopHolidaysQuery = {
  __typename?: 'Query';
  shop?: {
    __typename?: 'Shop';
    holidays: Array<
      { __typename?: 'ShopHoliday' } & {
        ' $fragmentRefs'?: {
          ShopHolidayDetailsFragment: ShopHolidayDetailsFragment;
        };
      }
    >;
  } | null;
};

export type CreateShopInAccountMutationVariables = Exact<{
  input: CreateShopInput;
}>;

export type CreateShopInAccountMutation = {
  __typename?: 'Mutation';
  createShop:
    | { __typename: 'InvalidShopInputsError'; items: Array<string> }
    | { __typename: 'MissingAccountError'; accountId: string }
    | {
        __typename: 'ShopCreated';
        shop: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopDetailsFragment: ShopDetailsFragment };
        };
      };
};

export type UpdateShopMutationVariables = Exact<{
  input: UpdateShopInput;
}>;

export type UpdateShopMutation = {
  __typename?: 'Mutation';
  updateShop:
    | { __typename: 'InvalidShopInputsError'; items: Array<string> }
    | { __typename: 'MissingShopError'; shopId: string }
    | {
        __typename: 'ShopUpdated';
        shop: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopDetailsFragment: ShopDetailsFragment };
        };
      };
};

export type DeleteShopMutationVariables = Exact<{
  input: DeleteShopInput;
}>;

export type DeleteShopMutation = {
  __typename?: 'Mutation';
  deleteShop:
    | { __typename: 'MissingShopError'; shopId: string }
    | { __typename: 'ShopDeleted'; shopId: string };
};

export type AddLaneToShopMutationVariables = Exact<{
  input: AddLaneToShopInput;
}>;

export type AddLaneToShopMutation = {
  __typename?: 'Mutation';
  addLaneToShop:
    | { __typename: 'InvalidShopLaneInputsError'; items: Array<string> }
    | { __typename: 'MissingShopError'; shopId: string }
    | {
        __typename: 'ShopLaneCreated';
        shopLane: {
          __typename?: 'ShopLane';
          id: string;
          name: string;
          ordinal: number;
          dailyAppointmentLimit: number;
          appointmentsPerIntervalLimit: number;
        };
      };
};

export type SetShopLanePositionMutationVariables = Exact<{
  input: SetShopLanePositionInput;
}>;

export type SetShopLanePositionMutation = {
  __typename?: 'Mutation';
  setShopLanePosition:
    | { __typename: 'InvalidShopLaneInputsError'; items: Array<string> }
    | { __typename: 'MissingShopLaneError'; shopLaneId: string }
    | {
        __typename: 'ShopLanePositionUpdated';
        shopLane: {
          __typename?: 'ShopLane';
          id: string;
          name: string;
          ordinal: number;
          dailyAppointmentLimit: number;
          appointmentsPerIntervalLimit: number;
        };
      };
};

export type UpdateShopLaneMutationVariables = Exact<{
  input: UpdateShopLaneInput;
}>;

export type UpdateShopLaneMutation = {
  __typename?: 'Mutation';
  updateShopLane:
    | { __typename: 'InvalidShopLaneInputsError'; items: Array<string> }
    | { __typename: 'MissingShopLaneError'; shopLaneId: string }
    | {
        __typename: 'ShopLaneUpdated';
        shopLane: {
          __typename?: 'ShopLane';
          id: string;
          name: string;
          ordinal: number;
          dailyAppointmentLimit: number;
          appointmentsPerIntervalLimit: number;
        };
      };
};

export type DeleteShopLaneMutationVariables = Exact<{
  input: DeleteShopLaneInput;
}>;

export type DeleteShopLaneMutation = {
  __typename?: 'Mutation';
  deleteShopLane:
    | { __typename: 'MissingShopLaneError'; shopLaneId: string }
    | { __typename: 'ShopLaneDeleted'; shopLaneId: string };
};

export type AddHolidayToShopMutationVariables = Exact<{
  input: AddHolidayToShopInput;
}>;

export type AddHolidayToShopMutation = {
  __typename?: 'Mutation';
  addHolidayToShop:
    | { __typename: 'InvalidShopHolidayInputsError'; items: Array<string> }
    | { __typename: 'MissingShopError'; shopId: string }
    | {
        __typename: 'ShopHolidayCreated';
        shopHoliday: { __typename?: 'ShopHoliday' } & {
          ' $fragmentRefs'?: {
            ShopHolidayDetailsFragment: ShopHolidayDetailsFragment;
          };
        };
      };
};

export type UpdateShopHolidayMutationVariables = Exact<{
  input: UpdateShopHolidayInput;
}>;

export type UpdateShopHolidayMutation = {
  __typename?: 'Mutation';
  updateShopHoliday:
    | { __typename: 'InvalidShopHolidayInputsError'; items: Array<string> }
    | { __typename: 'MissingShopError' }
    | { __typename: 'MissingShopHolidayError'; shopHolidayId: string }
    | {
        __typename: 'ShopHolidayUpdated';
        shopHoliday: { __typename?: 'ShopHoliday' } & {
          ' $fragmentRefs'?: {
            ShopHolidayDetailsFragment: ShopHolidayDetailsFragment;
          };
        };
      };
};

export type DeleteShopHolidayMutationVariables = Exact<{
  input: DeleteShopHolidayInput;
}>;

export type DeleteShopHolidayMutation = {
  __typename?: 'Mutation';
  deleteShopHoliday:
    | { __typename: 'MissingShopError' }
    | { __typename: 'MissingShopHolidayError'; shopHolidayId: string }
    | { __typename: 'ShopHolidayDeleted'; shopHolidayId: string };
};

export const ShopMetaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopMetaFragment, unknown>;
export const ShopDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopDetailsFragment, unknown>;
export const ShopHourDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopHourDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopHour' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isoDayOfWeek' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopHourDetailsFragment, unknown>;
export const ShopLaneDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopLaneDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopLane' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ordinal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentsPerIntervalLimit' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopLaneDetailsFragment, unknown>;
export const ShopHolidayDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopHolidayDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopHoliday' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'holidayDateType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dayOfMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoWeekday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nthOccurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopHolidayDetailsFragment, unknown>;
export const ShopsInAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shopsInAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shops' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ShopMeta' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopsInAccountQuery, ShopsInAccountQueryVariables>;
export const ShopsInRooftopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shopsInRooftop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rooftopId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooftop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'rooftopId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shops' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ShopMeta' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopsInRooftopQuery, ShopsInRooftopQueryVariables>;
export const GetShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ShopDetails' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShopQuery, GetShopQueryVariables>;
export const GetShopHoursDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getShopHours' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shopId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shopId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hours' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShopHourDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopHourDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopHour' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isoDayOfWeek' } },
          { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShopHoursQuery, GetShopHoursQueryVariables>;
export const GetShopLanesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getShopLanes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shopId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shopId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lanes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShopLaneDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopLaneDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopLane' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ordinal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentsPerIntervalLimit' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShopLanesQuery, GetShopLanesQueryVariables>;
export const GetShopHolidaysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getShopHolidays' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shopId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shopId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'holidays' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShopHolidayDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopHolidayDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopHoliday' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'holidayDateType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dayOfMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoWeekday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nthOccurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetShopHolidaysQuery,
  GetShopHolidaysQueryVariables
>;
export const CreateShopInAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createShopInAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopCreated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shop' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ShopDetails' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingAccountError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateShopInAccountMutation,
  CreateShopInAccountMutationVariables
>;
export const UpdateShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopUpdated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shop' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ShopDetails' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateShopMutation, UpdateShopMutationVariables>;
export const DeleteShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopDeleted' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteShopMutation, DeleteShopMutationVariables>;
export const AddLaneToShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addLaneToShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddLaneToShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addLaneToShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLaneCreated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ordinal' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'dailyAppointmentLimit',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'appointmentsPerIntervalLimit',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopLaneInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddLaneToShopMutation,
  AddLaneToShopMutationVariables
>;
export const SetShopLanePositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setShopLanePosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetShopLanePositionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShopLanePosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLanePositionUpdated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ordinal' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'dailyAppointmentLimit',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'appointmentsPerIntervalLimit',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopLaneInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopLaneError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetShopLanePositionMutation,
  SetShopLanePositionMutationVariables
>;
export const UpdateShopLaneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateShopLane' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateShopLaneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShopLane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLaneUpdated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ordinal' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'dailyAppointmentLimit',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'appointmentsPerIntervalLimit',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopLaneInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopLaneError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShopLaneMutation,
  UpdateShopLaneMutationVariables
>;
export const DeleteShopLaneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteShopLane' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteShopLaneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteShopLane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLaneDeleted' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopLaneError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteShopLaneMutation,
  DeleteShopLaneMutationVariables
>;
export const AddHolidayToShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addHolidayToShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddHolidayToShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addHolidayToShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopHolidayCreated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopHoliday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ShopHolidayDetails',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'InvalidShopHolidayInputsError',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopHolidayDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopHoliday' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'holidayDateType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dayOfMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoWeekday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nthOccurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddHolidayToShopMutation,
  AddHolidayToShopMutationVariables
>;
export const UpdateShopHolidayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateShopHoliday' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateShopHolidayInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShopHoliday' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopHolidayUpdated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopHoliday' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ShopHolidayDetails',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'InvalidShopHolidayInputsError',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopHolidayError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopHolidayId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopHolidayDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopHoliday' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'holidayDateType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dayOfMonth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isoWeekday' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nthOccurrence' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShopHolidayMutation,
  UpdateShopHolidayMutationVariables
>;
export const DeleteShopHolidayDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteShopHoliday' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteShopHolidayInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteShopHoliday' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopHolidayDeleted' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopHolidayId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopHolidayError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopHolidayId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteShopHolidayMutation,
  DeleteShopHolidayMutationVariables
>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AddHolidayToShopResponse: [
      'InvalidShopHolidayInputsError',
      'MissingShopError',
      'ShopHolidayCreated',
    ],
    AddLaneToShopResponse: [
      'InvalidShopLaneInputsError',
      'MissingShopError',
      'ShopLaneCreated',
    ],
    AppointmentResponseMissingSettingsAppointmentError: [
      'AppointmentResponse',
      'MissingSettingsAppointmentError',
    ],
    CreateShopResponse: [
      'InvalidShopInputsError',
      'MissingAccountError',
      'ShopCreated',
    ],
    DeleteShopHolidayResponse: [
      'MissingShopError',
      'MissingShopHolidayError',
      'ShopHolidayDeleted',
    ],
    DeleteShopLaneResponse: ['MissingShopLaneError', 'ShopLaneDeleted'],
    DeleteShopResponse: ['MissingShopError', 'ShopDeleted'],
    MapShopServiceCategoryToLaneResponse: [
      'MappedShopServiceCategoryToLane',
      'MissingShopLaneError',
      'MissingShopServiceCategoryError',
    ],
    Node: ['Account', 'Rooftop', 'Shop'],
    SetShopLanePositionResponse: [
      'InvalidShopLaneInputsError',
      'MissingShopLaneError',
      'ShopLanePositionUpdated',
    ],
    UpdateShopHolidayResponse: [
      'InvalidShopHolidayInputsError',
      'MissingShopError',
      'MissingShopHolidayError',
      'ShopHolidayUpdated',
    ],
    UpdateShopLaneResponse: [
      'InvalidShopLaneInputsError',
      'MissingShopLaneError',
      'ShopLaneUpdated',
    ],
    UpdateShopResponse: [
      'InvalidShopInputsError',
      'MissingShopError',
      'ShopUpdated',
    ],
  },
};
export default result;

export type AccountKeySpecifier = ('id' | 'shops' | AccountKeySpecifier)[];
export type AccountFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  shops?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AppointmentResponseKeySpecifier = (
  | 'apptDate'
  | 'apptId'
  | 'apptTime'
  | 'checkSum'
  | 'comments'
  | 'customerContactInfo'
  | 'customerFullName'
  | 'customerPartyId'
  | 'customerTransportation'
  | 'customerWaiterFlag'
  | 'dealerReservationist'
  | 'dealerServiceAdvisor'
  | 'dispatchMakeCode'
  | 'lineCount'
  | 'opCount'
  | 'originAppl'
  | 'originCode'
  | 'partsCount'
  | 'promiseDate'
  | 'promiseTime'
  | 'remarks'
  | 'vehicleId'
  | 'vehicleModel'
  | 'vehicleModelYear'
  | 'vehicleOdometerStatus'
  | AppointmentResponseKeySpecifier
)[];
export type AppointmentResponseFieldPolicy = {
  apptDate?: FieldPolicy<any> | FieldReadFunction<any>;
  apptId?: FieldPolicy<any> | FieldReadFunction<any>;
  apptTime?: FieldPolicy<any> | FieldReadFunction<any>;
  checkSum?: FieldPolicy<any> | FieldReadFunction<any>;
  comments?: FieldPolicy<any> | FieldReadFunction<any>;
  customerContactInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  customerFullName?: FieldPolicy<any> | FieldReadFunction<any>;
  customerPartyId?: FieldPolicy<any> | FieldReadFunction<any>;
  customerTransportation?: FieldPolicy<any> | FieldReadFunction<any>;
  customerWaiterFlag?: FieldPolicy<any> | FieldReadFunction<any>;
  dealerReservationist?: FieldPolicy<any> | FieldReadFunction<any>;
  dealerServiceAdvisor?: FieldPolicy<any> | FieldReadFunction<any>;
  dispatchMakeCode?: FieldPolicy<any> | FieldReadFunction<any>;
  lineCount?: FieldPolicy<any> | FieldReadFunction<any>;
  opCount?: FieldPolicy<any> | FieldReadFunction<any>;
  originAppl?: FieldPolicy<any> | FieldReadFunction<any>;
  originCode?: FieldPolicy<any> | FieldReadFunction<any>;
  partsCount?: FieldPolicy<any> | FieldReadFunction<any>;
  promiseDate?: FieldPolicy<any> | FieldReadFunction<any>;
  promiseTime?: FieldPolicy<any> | FieldReadFunction<any>;
  remarks?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleId?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleModel?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleModelYear?: FieldPolicy<any> | FieldReadFunction<any>;
  vehicleOdometerStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidShopHolidayInputsErrorKeySpecifier = (
  | 'items'
  | InvalidShopHolidayInputsErrorKeySpecifier
)[];
export type InvalidShopHolidayInputsErrorFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidShopInputsErrorKeySpecifier = (
  | 'items'
  | InvalidShopInputsErrorKeySpecifier
)[];
export type InvalidShopInputsErrorFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidShopLaneInputsErrorKeySpecifier = (
  | 'items'
  | InvalidShopLaneInputsErrorKeySpecifier
)[];
export type InvalidShopLaneInputsErrorFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MappedShopServiceCategoryToLaneKeySpecifier = (
  | 'shopServiceCategory'
  | MappedShopServiceCategoryToLaneKeySpecifier
)[];
export type MappedShopServiceCategoryToLaneFieldPolicy = {
  shopServiceCategory?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingAccountErrorKeySpecifier = (
  | 'accountId'
  | MissingAccountErrorKeySpecifier
)[];
export type MissingAccountErrorFieldPolicy = {
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingSettingsAppointmentErrorKeySpecifier = (
  | 'message'
  | MissingSettingsAppointmentErrorKeySpecifier
)[];
export type MissingSettingsAppointmentErrorFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingShopErrorKeySpecifier = (
  | 'shopId'
  | MissingShopErrorKeySpecifier
)[];
export type MissingShopErrorFieldPolicy = {
  shopId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingShopHolidayErrorKeySpecifier = (
  | 'shopHolidayId'
  | MissingShopHolidayErrorKeySpecifier
)[];
export type MissingShopHolidayErrorFieldPolicy = {
  shopHolidayId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingShopLaneErrorKeySpecifier = (
  | 'shopLaneId'
  | MissingShopLaneErrorKeySpecifier
)[];
export type MissingShopLaneErrorFieldPolicy = {
  shopLaneId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingShopServiceCategoryErrorKeySpecifier = (
  | 'shopServiceCategoryId'
  | MissingShopServiceCategoryErrorKeySpecifier
)[];
export type MissingShopServiceCategoryErrorFieldPolicy = {
  shopServiceCategoryId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | 'addHolidayToShop'
  | 'addLaneToShop'
  | 'createAppointment'
  | 'createShop'
  | 'deleteShop'
  | 'deleteShopHoliday'
  | 'deleteShopLane'
  | 'mapShopServiceCategoryToLane'
  | 'setShopLanePosition'
  | 'updateShop'
  | 'updateShopHoliday'
  | 'updateShopLane'
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  addHolidayToShop?: FieldPolicy<any> | FieldReadFunction<any>;
  addLaneToShop?: FieldPolicy<any> | FieldReadFunction<any>;
  createAppointment?: FieldPolicy<any> | FieldReadFunction<any>;
  createShop?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShop?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShopHoliday?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShopLane?: FieldPolicy<any> | FieldReadFunction<any>;
  mapShopServiceCategoryToLane?: FieldPolicy<any> | FieldReadFunction<any>;
  setShopLanePosition?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShop?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShopHoliday?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NodeKeySpecifier = ('id' | NodeKeySpecifier)[];
export type NodeFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | 'endCursor'
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'startCursor'
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'account'
  | 'rooftop'
  | 'shop'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  rooftop?: FieldPolicy<any> | FieldReadFunction<any>;
  shop?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RooftopKeySpecifier = ('id' | 'shops' | RooftopKeySpecifier)[];
export type RooftopFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  shops?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopKeySpecifier = (
  | 'city'
  | 'dailyAppointmentLimit'
  | 'holidays'
  | 'hours'
  | 'id'
  | 'intervalDurationMinutes'
  | 'lanes'
  | 'name'
  | 'serviceCategories'
  | 'serviceLeadXmlAddress'
  | 'state'
  | 'status'
  | 'streetAddress'
  | 'timezone'
  | 'zipCode'
  | ShopKeySpecifier
)[];
export type ShopFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  dailyAppointmentLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  holidays?: FieldPolicy<any> | FieldReadFunction<any>;
  hours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intervalDurationMinutes?: FieldPolicy<any> | FieldReadFunction<any>;
  lanes?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceCategories?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceLeadXmlAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  streetAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  timezone?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ShopConnectionKeySpecifier
)[];
export type ShopConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopCreatedKeySpecifier = ('shop' | ShopCreatedKeySpecifier)[];
export type ShopCreatedFieldPolicy = {
  shop?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopDeletedKeySpecifier = ('shopId' | ShopDeletedKeySpecifier)[];
export type ShopDeletedFieldPolicy = {
  shopId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopEdgeKeySpecifier = ('cursor' | 'node' | ShopEdgeKeySpecifier)[];
export type ShopEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopHolidayKeySpecifier = (
  | 'dayOfMonth'
  | 'holidayDateType'
  | 'id'
  | 'isActive'
  | 'isoMonth'
  | 'isoWeekday'
  | 'name'
  | 'nthOccurrence'
  | ShopHolidayKeySpecifier
)[];
export type ShopHolidayFieldPolicy = {
  dayOfMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  holidayDateType?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isActive?: FieldPolicy<any> | FieldReadFunction<any>;
  isoMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  isoWeekday?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  nthOccurrence?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopHolidayCreatedKeySpecifier = (
  | 'shopHoliday'
  | ShopHolidayCreatedKeySpecifier
)[];
export type ShopHolidayCreatedFieldPolicy = {
  shopHoliday?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopHolidayDeletedKeySpecifier = (
  | 'shopHolidayId'
  | ShopHolidayDeletedKeySpecifier
)[];
export type ShopHolidayDeletedFieldPolicy = {
  shopHolidayId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopHolidayUpdatedKeySpecifier = (
  | 'shopHoliday'
  | ShopHolidayUpdatedKeySpecifier
)[];
export type ShopHolidayUpdatedFieldPolicy = {
  shopHoliday?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopHourKeySpecifier = (
  | 'closeTime'
  | 'isoDayOfWeek'
  | 'openTime'
  | ShopHourKeySpecifier
)[];
export type ShopHourFieldPolicy = {
  closeTime?: FieldPolicy<any> | FieldReadFunction<any>;
  isoDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  openTime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneKeySpecifier = (
  | 'appointmentsPerIntervalLimit'
  | 'dailyAppointmentLimit'
  | 'id'
  | 'name'
  | 'ordinal'
  | ShopLaneKeySpecifier
)[];
export type ShopLaneFieldPolicy = {
  appointmentsPerIntervalLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  dailyAppointmentLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  ordinal?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneCreatedKeySpecifier = (
  | 'shopLane'
  | ShopLaneCreatedKeySpecifier
)[];
export type ShopLaneCreatedFieldPolicy = {
  shopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneDeletedKeySpecifier = (
  | 'shopLaneId'
  | ShopLaneDeletedKeySpecifier
)[];
export type ShopLaneDeletedFieldPolicy = {
  shopLaneId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLanePositionUpdatedKeySpecifier = (
  | 'shopLane'
  | ShopLanePositionUpdatedKeySpecifier
)[];
export type ShopLanePositionUpdatedFieldPolicy = {
  shopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneUpdatedKeySpecifier = (
  | 'shopLane'
  | ShopLaneUpdatedKeySpecifier
)[];
export type ShopLaneUpdatedFieldPolicy = {
  shopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopServiceCategoryKeySpecifier = (
  | 'id'
  | 'minimumRequiredLane'
  | 'name'
  | ShopServiceCategoryKeySpecifier
)[];
export type ShopServiceCategoryFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  minimumRequiredLane?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopUpdatedKeySpecifier = ('shop' | ShopUpdatedKeySpecifier)[];
export type ShopUpdatedFieldPolicy = {
  shop?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  Account?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountKeySpecifier
      | (() => undefined | AccountKeySpecifier);
    fields?: AccountFieldPolicy;
  };
  AppointmentResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppointmentResponseKeySpecifier
      | (() => undefined | AppointmentResponseKeySpecifier);
    fields?: AppointmentResponseFieldPolicy;
  };
  InvalidShopHolidayInputsError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvalidShopHolidayInputsErrorKeySpecifier
      | (() => undefined | InvalidShopHolidayInputsErrorKeySpecifier);
    fields?: InvalidShopHolidayInputsErrorFieldPolicy;
  };
  InvalidShopInputsError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvalidShopInputsErrorKeySpecifier
      | (() => undefined | InvalidShopInputsErrorKeySpecifier);
    fields?: InvalidShopInputsErrorFieldPolicy;
  };
  InvalidShopLaneInputsError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvalidShopLaneInputsErrorKeySpecifier
      | (() => undefined | InvalidShopLaneInputsErrorKeySpecifier);
    fields?: InvalidShopLaneInputsErrorFieldPolicy;
  };
  MappedShopServiceCategoryToLane?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MappedShopServiceCategoryToLaneKeySpecifier
      | (() => undefined | MappedShopServiceCategoryToLaneKeySpecifier);
    fields?: MappedShopServiceCategoryToLaneFieldPolicy;
  };
  MissingAccountError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingAccountErrorKeySpecifier
      | (() => undefined | MissingAccountErrorKeySpecifier);
    fields?: MissingAccountErrorFieldPolicy;
  };
  MissingSettingsAppointmentError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingSettingsAppointmentErrorKeySpecifier
      | (() => undefined | MissingSettingsAppointmentErrorKeySpecifier);
    fields?: MissingSettingsAppointmentErrorFieldPolicy;
  };
  MissingShopError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingShopErrorKeySpecifier
      | (() => undefined | MissingShopErrorKeySpecifier);
    fields?: MissingShopErrorFieldPolicy;
  };
  MissingShopHolidayError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingShopHolidayErrorKeySpecifier
      | (() => undefined | MissingShopHolidayErrorKeySpecifier);
    fields?: MissingShopHolidayErrorFieldPolicy;
  };
  MissingShopLaneError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingShopLaneErrorKeySpecifier
      | (() => undefined | MissingShopLaneErrorKeySpecifier);
    fields?: MissingShopLaneErrorFieldPolicy;
  };
  MissingShopServiceCategoryError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingShopServiceCategoryErrorKeySpecifier
      | (() => undefined | MissingShopServiceCategoryErrorKeySpecifier);
    fields?: MissingShopServiceCategoryErrorFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MutationKeySpecifier
      | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  Node?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | NodeKeySpecifier | (() => undefined | NodeKeySpecifier);
    fields?: NodeFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PageInfoKeySpecifier
      | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  Rooftop?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RooftopKeySpecifier
      | (() => undefined | RooftopKeySpecifier);
    fields?: RooftopFieldPolicy;
  };
  Shop?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ShopKeySpecifier | (() => undefined | ShopKeySpecifier);
    fields?: ShopFieldPolicy;
  };
  ShopConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopConnectionKeySpecifier
      | (() => undefined | ShopConnectionKeySpecifier);
    fields?: ShopConnectionFieldPolicy;
  };
  ShopCreated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopCreatedKeySpecifier
      | (() => undefined | ShopCreatedKeySpecifier);
    fields?: ShopCreatedFieldPolicy;
  };
  ShopDeleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopDeletedKeySpecifier
      | (() => undefined | ShopDeletedKeySpecifier);
    fields?: ShopDeletedFieldPolicy;
  };
  ShopEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopEdgeKeySpecifier
      | (() => undefined | ShopEdgeKeySpecifier);
    fields?: ShopEdgeFieldPolicy;
  };
  ShopHoliday?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopHolidayKeySpecifier
      | (() => undefined | ShopHolidayKeySpecifier);
    fields?: ShopHolidayFieldPolicy;
  };
  ShopHolidayCreated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopHolidayCreatedKeySpecifier
      | (() => undefined | ShopHolidayCreatedKeySpecifier);
    fields?: ShopHolidayCreatedFieldPolicy;
  };
  ShopHolidayDeleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopHolidayDeletedKeySpecifier
      | (() => undefined | ShopHolidayDeletedKeySpecifier);
    fields?: ShopHolidayDeletedFieldPolicy;
  };
  ShopHolidayUpdated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopHolidayUpdatedKeySpecifier
      | (() => undefined | ShopHolidayUpdatedKeySpecifier);
    fields?: ShopHolidayUpdatedFieldPolicy;
  };
  ShopHour?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopHourKeySpecifier
      | (() => undefined | ShopHourKeySpecifier);
    fields?: ShopHourFieldPolicy;
  };
  ShopLane?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneKeySpecifier
      | (() => undefined | ShopLaneKeySpecifier);
    fields?: ShopLaneFieldPolicy;
  };
  ShopLaneCreated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneCreatedKeySpecifier
      | (() => undefined | ShopLaneCreatedKeySpecifier);
    fields?: ShopLaneCreatedFieldPolicy;
  };
  ShopLaneDeleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneDeletedKeySpecifier
      | (() => undefined | ShopLaneDeletedKeySpecifier);
    fields?: ShopLaneDeletedFieldPolicy;
  };
  ShopLanePositionUpdated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLanePositionUpdatedKeySpecifier
      | (() => undefined | ShopLanePositionUpdatedKeySpecifier);
    fields?: ShopLanePositionUpdatedFieldPolicy;
  };
  ShopLaneUpdated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneUpdatedKeySpecifier
      | (() => undefined | ShopLaneUpdatedKeySpecifier);
    fields?: ShopLaneUpdatedFieldPolicy;
  };
  ShopServiceCategory?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopServiceCategoryKeySpecifier
      | (() => undefined | ShopServiceCategoryKeySpecifier);
    fields?: ShopServiceCategoryFieldPolicy;
  };
  ShopUpdated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopUpdatedKeySpecifier
      | (() => undefined | ShopUpdatedKeySpecifier);
    fields?: ShopUpdatedFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
/* This is an auto-generated file by generateApolloMergeableTypes.js */

export const mergeableTypesArray = [
  'Account',
  'AppointmentResponse',
  'InvalidShopHolidayInputsError',
  'InvalidShopInputsError',
  'InvalidShopLaneInputsError',
  'MappedShopServiceCategoryToLane',
  'MissingAccountError',
  'MissingSettingsAppointmentError',
  'MissingShopError',
  'MissingShopHolidayError',
  'MissingShopLaneError',
  'MissingShopServiceCategoryError',
  'Mutation',
  'Node',
  'PageInfo',
  'Query',
  'Rooftop',
  'Shop',
  'ShopConnection',
  'ShopCreated',
  'ShopDeleted',
  'ShopEdge',
  'ShopHoliday',
  'ShopHolidayCreated',
  'ShopHolidayDeleted',
  'ShopHolidayUpdated',
  'ShopHour',
  'ShopLane',
  'ShopLaneCreated',
  'ShopLaneDeleted',
  'ShopLanePositionUpdated',
  'ShopLaneUpdated',
  'ShopServiceCategory',
  'ShopUpdated',
];
